import { FunctionBlockUiState } from '@/store/modules/functionBlockUi/types'

export const state: FunctionBlockUiState = {
}
